document.addEventListener("DOMContentLoaded", function () {
    const resourcesByProductBlocks = document.querySelectorAll("[data-prb-combobox]");

    if (resourcesByProductBlocks.length) {
        import(/* webpackChunkName: "resources-by-product-block" */ "/Features/SupportByProduct/js/resources-by-product-block.js").then(async (module) => {
            resourcesByProductBlocks.forEach(element => {
                new module.default(element);
            });
        });
    }
});